import { Button, ButtonSize, ButtonAppearance, MenuItem, Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.SECONDARY,
})`
  position: relative;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

interface MenuItemStyledProps {
  disabled: boolean;
}

export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
    display: flex;
  `};
  ${(props: MenuItemStyledProps) =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
interface PhotoNotificationStyledProps {
  isMenuItem?: boolean;
}

export const PhotoNotificationStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
})<PhotoNotificationStyledProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii['400']};
    background-color: ${theme.colors.bechtel.red};
    height: ${theme.spacings['500']};
    width: ${theme.spacings['500']};
    line-height: ${theme.spacings['500']};
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes['200']};
    ${(props: PhotoNotificationStyledProps) =>
      !props.isMenuItem &&
      css`
        position: absolute;
        top: -${theme.spacings[300]};
        right: -${theme.spacings[200]};
      `}
  `}
`;
